module.exports = __webpack_public_path__ + "img/feedBack.d107e7dc.png";